import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'

export default class BWLDashboard extends WebComponent {

  constructor() {
    super()
  }

  get translationFile() {
    return './views/Dashboard/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.render()
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('dashboard.bwl.title')}">
      </isceco-title>
    `
  }

}
customElements.define('eko-frontend-bwl-dashboard', BWLDashboard)
